import api from './api';

export interface Notification {
  id: string | number;
  title: string;
  message: string;
  type: 'INFO' | 'WARNING' | 'ERROR' | 'SUCCESS';
  isRead: boolean;
  timestamp: string;
  relatedEntityType?: string;
  relatedEntityId?: string;
}

export interface UnreadCountResponse {
  count: number;
}

const notificationService = {
  // Kullanicinin bildirimlerini getir
  getNotifications: async (limit: number = 20, unreadOnly: boolean = false): Promise<Notification[]> => {
    const response = await api.get<Notification[]>(`/notifications?limit=${limit}&unreadOnly=${unreadOnly}`);
    return response.data;
  },

  // Sistem bildirimlerini getir (cihaz durumu, gec kalanlar vs.)
  getSystemNotifications: async (): Promise<Notification[]> => {
    const response = await api.get<Notification[]>('/notifications/system');
    return response.data;
  },

  // Okunmamis bildirim sayisini getir
  getUnreadCount: async (): Promise<number> => {
    const response = await api.get<UnreadCountResponse>('/notifications/unread-count');
    return response.data.count;
  },

  // Bildirimi okundu olarak isaretle
  markAsRead: async (id: string | number): Promise<void> => {
    await api.put(`/notifications/${id}/read`);
  },

  // Tum bildirimleri okundu olarak isaretle
  markAllAsRead: async (): Promise<void> => {
    await api.put('/notifications/read-all');
  },

  // Bildirimi sil
  deleteNotification: async (id: string | number): Promise<void> => {
    await api.delete(`/notifications/${id}`);
  },

  // Bildirim olustur
  createNotification: async (data: {
    userId: number;
    title: string;
    message: string;
    type?: string;
    relatedEntityType?: string;
    relatedEntityId?: string;
  }): Promise<{ id: number }> => {
    const response = await api.post<{ id: number }>('/notifications', data);
    return response.data;
  }
};

export default notificationService;
